import useFetch from "../../../hooks/useFetch";
import { useContext, useEffect } from "react";
import { PostContext } from "../../../contexts/PostContext";
import { Loader } from "../../atoms/Loader/Loader";
import { useDocumentTitleLoading } from "../../../hooks/useDocumentTitle";
import { FilterContextProvider } from "../../../contexts/FilterContext";
import { referencesRepository } from "../../../repository/references.repository";
import ReferenceControlTemplate from "../../templates/ReferenceControlTemplate/ReferenceControlTemplate";

const ReferenceControl = () => {
  const { data, fetchData, isReady } = useFetch();
  const { isResponseOk } = useContext(PostContext);

  useDocumentTitleLoading();

  useEffect(() => {
    if (isResponseOk || !data) {
      fetchData(referencesRepository.getReferences());
    }
  }, [isResponseOk]);

  return data ? (
    <FilterContextProvider>
      <ReferenceControlTemplate data={data} isReady={isReady} />
    </FilterContextProvider>
  ) : (
    <Loader />
  );
};

export default ReferenceControl;
